import { Box, CircularProgress } from '@mui/material'
import { Suspense, useEffect } from 'react'

import { siteActiveLicenses } from '../../api/services/apiService'
import QueryErrorBoundary from '../../components/QueryErrorBoundary'
import DashboardsContainer from '../../dashboards/DashboardsContainer'
import ProductsContainer from '../../products/ProductsContainer'
import QualityControlContainer from '../../qualityControl/QualityControlContainer'
import ReportsContainer from '../../reports/ReportsContainer'
import { setProductLicenses } from '../../store/authSlice'
import { useAppDispatch, useAppSelector, useCurrentSite } from '../../store/store.hooks'
import { logger } from '../../utils/logger'

const SidebarNav = ({ onClose, onOpen, onToggle, isOpen = true,  }: { onClose?: () => void; onOpen?: () => void; onToggle?: () => void; isOpen?: boolean }) => {
  const currentSite = useCurrentSite()
  const licenses = useAppSelector((state) => state.auth.productLicenses)
  const licenseNames = licenses?.map((l) => l.licenseName) ?? []

  const dispatch = useAppDispatch()

  useEffect(() => {
    logger.log('[SidebarNav] Product licenses:', licenses)

    if (!currentSite) return
    siteActiveLicenses.list(currentSite.id).then((licenses) => {
      dispatch(setProductLicenses(licenses))
    })
  }, [currentSite?.id])
  return (
    <Box 
    id="sidebar"
    sx={{ flexGrow: 1, overflowY: 'auto' }}>
      <QueryErrorBoundary key={currentSite?.id}>
        <Suspense
          fallback={
            <Box sx={{ display: 'flex', justifyContent: 'center', p: 2 }}>
              <CircularProgress color="secondary" size={32} />
            </Box>
          }
        >
          <ReportsContainer isOpen={isOpen} onOpen={onOpen} />
        </Suspense>
      </QueryErrorBoundary>
      <DashboardsContainer isOpen={isOpen} onOpen={onOpen} onClose={onClose} />
      {licenses?.some((l) => l.licenseName === 'WeControl') && <QualityControlContainer isOpen={isOpen} onClose={onClose} />}
      {currentSite?.isProductViewActivated && <ProductsContainer isOpen={isOpen} siteLicenses={licenseNames} onClose={onClose} />}
    </Box>
  )
}

export default SidebarNav
